
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/threads-downloader",
      function () {
        return require("private-next-pages/threads-downloader/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/threads-downloader"])
      });
    }
  